import data from './EPedalo.yaml'
import { WithPage } from "../Components/PageSections/WithPage";

export default function EPedalo() {

  return WithPage(data,'epedalo')
}


